import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import HomeCard from './HomeCard';
import Table from '../Table';
import { useValidatedEventsManagementReport } from '../../modules/organisation/hooks/useGroupEventsReport';
import {
  equipmentNameLink,
  identifiedIssue,
  estHoursLost,
  estHoursLostAvoided,
  estEventCosts,
  estEventCostsAvoided,
  estEventCostsPrevented,
} from './columns';
import useLocalisedColumns from '../../hooks/useLocalisedColumns';

function ValidatedEventsMgnt({ currency }) {
  const { t } = useTranslation();
  const validatedEventsManagementReport = useValidatedEventsManagementReport();

  const columns = useMemo(() => [
    equipmentNameLink,
    identifiedIssue,
    estHoursLost,
    estHoursLostAvoided,
    estEventCosts(currency),
    estEventCostsAvoided(currency),
    estEventCostsPrevented(currency),
  ], [currency]);
  const localisedColumns = useLocalisedColumns(columns);
  if(!validatedEventsManagementReport) return null;

  const {_state_: { loading, error } = {}, items = []} = validatedEventsManagementReport || {};

  return (
    <HomeCard
      header={t('home.common.validated-events')}
      headerLink={{to: '/events?status=valid', text: t('home.common.all-validated-events')}}
      loading={loading}
      error={error}
    >
      <div className="smaller-font-size-table-container">
        <Table
          data={items}
          keyField="alarm_id"
          loading={loading}
          columns={localisedColumns}
          condensed
        />
      </div>
    </HomeCard>
  );
}

export default ValidatedEventsMgnt;
